import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
} from "../services/types/ComponentTypes";

export const screen_117_invoices: ComponentConfig[] = [
  {
    componentType: LayoutTypes.SCREEN_GROUP,
    fabAction: {
      type: "add",
      screenId: "173",
      action: "modulev1/invoice_add_from_summary",
    },
    title: "Invoice",
    style: {
      backgroundColor: "#F9FAFB", // bg-gray-50 from design system
    },
    childComponents: [
      {
        componentType: LayoutTypes.GROUP,
        style: {
          backgroundColor: "#ffffff",
          direction: FlexDirection.COLUMN,
          borderRadius: 12, // Design system: rounded-lg (12px)
          padding: 16, // Design system: p-4 (16px)
        },
        childComponents: [
          {
            componentType: ComponentType.SUMMARY_LIST,
            titleValue: "invoice_no",
            Name: "invoice",
            SummeryActions: [
              // {
              //   Action: {
              //     Action: "Navigate",
              //     Navigate: "modulev1/invoice_add/<id>",
              //   },
              //   ActionType: "Edit",
              //   ScreenId: "158",
              // },
              {
                Action: {
                  Action: "PDF",
                  Settings: "invoice_pdf_view",
                },
                ActionType: "PDF_DOWNLOAD",
                tooltip: "Download PDF",
              },
            ],
            Form: {
              Name: "invoice",
              TableName: "invoice",
              View: "view_invoice_summary",
              Filter:
                "view_invoice_summary.soft_delete=0 order by view_invoice_summary.created_at desc",
              Fields: [
                {
                  IncludeLabel: true,
                  Label: "id",
                  BindValue: "id",
                  Json_Attribute: "id",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: false,
                },
                {
                  IncludeLabel: true,
                  Label: "Invoice No.",
                  BindValue: "invoice_no",
                  Json_Attribute: "invoice_no",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Invoice Date",
                  BindValue: "invoice_date",
                  Json_Attribute: "invoice_date",
                  componentType: ComponentType.DATE_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Customer",
                  BindValue: "customer_id",
                  Json_Attribute: "customer_name",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Amount",
                  BindValue: "amount",
                  Json_Attribute: "amount",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Status",
                  BindValue: "status",
                  Json_Attribute: "status",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
              ],
            },
          },
        ],
      },
    ],
  },
];


